<div class="w-full p-4 md:p-12" *transloco="let t">
  <div class="max-w-[400px] ml-auto mb-4">
    @if(mySalons[0]){
      <std-select direction="down" class="max-w-[400px]"
        typeOfFiltrableSelect="startsWith"
        customLabel="label-input"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
        [filterable]="false"
        [currentValue]="mySalons[0]"
        customClassContaier="border-primary custom-select"
        [bindValue]="'id'"
        [bindLabel]="'name'"
        placeholder="Seleziona salone"
        (onChangeValue)="getTimeSheetSalon($event)"
        [data]="mySalons"
        ></std-select
        >}
      </div>
      <div
    [ngClass]="{
      'pointer-events-none opacity-35 select-none': !currentSalon?.id
    }"
        >
        @if (showCalendar) {
          <std-calendar
          [calendarModes]="calendarModes"
            (changeEventTime)="moveEvent($event)"
            [scrollHours]="true"
            [translatePipe]="t"
            [canResizeEvents]="true"
            [showAllEvents]="true"
            
            weeklyShowHoursMode="daily"
            [daysOff]="[]"
            (close)="currentEventSelected = {}"
      (showEvent)="addUser = false;currentEventSelected= {};isEditEvent = false;hideSelectClient=false;searchedClient=null;userApplied=false;
        currentEventSelected = $event;
        currentEvent = $event;
        manageElementsEvent($event)
      "
      [hoursToScroll]="10"
            [mobileItems]="mobileItems"
            [arrayEvents]="arrayPrenotations"
            (close)="currentEvent = {}"
            (onDayClick)="addUser = false;currentEventSelected= {};suggestedTimeSlots = [];isEditEvent = false;hideSelectClient=false;searchedClient=null;userApplied=false;dateSelect($event)"
            [currentMode]="currentCalendarMode"
            [currentDate]="currentDate"
            (changeMode)="changeMode($event)"
            >
            <div
              customModal
              class="size-full p-5 bg-white w-full h-full min-w-[600px] max-w-[650px]"
              >
              <div class="w-full flex justify-between items-center">
                <div class="w-full h-full flex gap-2 items-center">
                  <div class="w-[6px] h-[44px] bg-[#D9D9D9]"></div>
                  <div class="flex flex-col items-start justify-center">
                    <div
                      class="text-[16px] text-[#102A35] font-medium leading-[19.2px]"
                      >
                      {{ getEventTime(currentEventSelected.dateStart) }}/
                      {{ getEventTime(currentEventSelected.dateEnd) }}
                    </div>
                    <div class="text-[20px] font-medium text-[#102A35] leading-6">
                      {{ currentEventSelected.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="w-full h-full flex flex-col items-start justify-start gap-5 mt-5"
                >
                <div
                  class="w-full h-full flex flex-col gap-2 items-start justify-start"
                  >
                  <div
                    class="text-base font-semibold leading-[19.2px] text-[#102A35]"
                    >
                    Attività
                  </div>
                  <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
                    {{ currentEventSelected.item?.name }}
                  </div>
                </div>
                <div
                  class="w-full h-full flex flex-col gap-2 items-start justify-start"
                  >
                  <div
                    class="text-base font-semibold leading-[19.2px] text-[#102A35]"
                    >
                    Operatore
                  </div>
                  <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
                    {{ currentEventSelected.operator?.firstName }}
                    {{ currentEventSelected.operator?.lastName }}
                  </div>
                </div>
                <div
                  class="w-full h-full flex flex-col gap-2 items-start justify-start"
                  >
                  <div
                    class="text-base font-semibold leading-[19.2px] text-[#102A35]"
                    >
                    Telefono
                  </div>
                  <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
                    {{
                    currentEventSelected.user ? currentEventSelected.user.phone : ""
                    }}
                  </div>
                </div>
                <div
                  class="w-full h-full flex flex-col gap-2 items-start justify-start"
                  >
                  <div
                    class="text-base font-semibold leading-[19.2px] text-[#102A35]"
                    >
                    Note
                  </div>
                  <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
                    {{
                    currentEventSelected.description
                    ? currentEventSelected.description
                    : ""
                    }}
                  </div>
                </div>
              </div>
              <div
                class="mt-[15px] w-full flex place-content-center"
                *transloco="let t"
                >
                @if (currentEventSelected?.completeEvent) {
                  <std-button
                    class="w-[32%]"
                    (click)="modalDelete = true; refreshCalendar()"
                    size="sm"
                    buttonClass="bg-red-500 text-white hover:bg-red-500 active:bg-red-500 focus:bg-red-500"
                    >{{ t("modal.delete") }}</std-button
                    >
                  }
                  <std-button
                    class="w-[32%] mx-[2%]"
            (click)="
              isEditEvent = true; showModalBooking = true; refreshCalendar()
            "
                    size="sm"
                    >{{ t("modal.edit") }}</std-button
                    >
                    @if(currentEventSelected?.user?.phone){<std-button
                      class="w-[32%]"
                      (click)="sendReminderWhatapp(t)"
                      size="sm"
                      >{{ t("sendReminderWhatapp") }}</std-button
                      >}
                    </div>
                  </div>
                </std-calendar>
              }
            </div>
            @if(showModalBooking){<std-modal
              [closeOnOutside]="false"
              cardClass="!max-w-[90vw] min-w-[440px]"
              [show]="showModalBooking"
              headerClass="bg-primary"
              (close)="showModalBooking = false"
              >
              <div header class="text-white">
                {{ isEditEvent ? "Modifica prenotazione" : "Crea prenotazione" }}
                {{ getFormattedDate(currentDate) }}
              </div>
              <div
                content
                [ngClass]="{'!pointer-events-none !opacity-50 !select-none': showModalSearchClient}"
                class="min-w-[250px] max-w-[400px] gap-4 grid max-h-[70vh] overflow-y-scroll custom-scrollbar"
                >
                @if(!isEditEvent){<std-select direction="down" class="max-w-[400px]"
                  typeOfFiltrableSelect="includes"
                  customLabel="label-input"
                  [filterable]="true"
                  customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                  label="Prodotto"
                  [currentValue]="myProducts[0]"
                  bindValue="id"
                  bindLabel="name"
                  (onChangeValue)="manageProduct($event)"
                  customClassContaier="border-primary custom-select"
                  placeholder="Seleziona prodotto"
                  [data]="myProducts"
                  ></std-select
                  >} @if(isEditEvent){
                  <std-select direction="down" class="max-w-[400px]"
                    typeOfFiltrableSelect="startsWith"
                    customLabel="label-input"
                    [filterable]="true"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                    label="Prodotto"
                    [currentValue]="currentEventSelected.item"
                    bindValue="id"
                    bindLabel="name"
                    (onChangeValue)="manageProduct($event)"
                    customClassContaier="border-primary custom-select"
                    placeholder="Seleziona prodotto"
                    [data]="myProducts"
                  ></std-select>
                }

                <std-input
                  customInputClass="custom-input"
                  customLabel="label-input"
                  labelPosition="top"
                  label="Prezzo"
                  placeholder="Prezzo"
                  [(ngModel)]="currentEvent.price"
                  type="number"
                ></std-input>

                @if(isEditEvent){
                  <std-select direction="down" class="max-w-[400px]"
                    typeOfFiltrableSelect="startsWith"
                    customLabel="label-input"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
      [currentValue]="{
        id: currentEventSelected.operator.id,
        fullName:
          currentEventSelected.operator.firstName +
          ' ' +
          currentEventSelected.operator.lastName
      }"
                    label="Operatore"
                    bindValue="id"
                    bindLabel="fullName"
                    (onChangeValue)="manageOperator($event)"
                    customClassContaier="border-primary custom-select"
                    placeholder="Seleziona operatore"
                    [data]="myOperators"
                  ></std-select>
                  @if(suggestedTimeSlots.length >0){
                    <div class="text-title text-primary label-input">Time slot consigliati</div>
                  }

                  @if(suggestedTimeSlots.length > 0){
                    <div
                      class="flex overflow-x-scroll gap-x-[4%] md:gap-x-[2%] custom-scrollbar pb-2 select-none"
                      >
                      @for (slot of suggestedTimeSlots; track $index) {
                        <div
                          (click)="selectSuggestedSlot(slot)"
                          class="w-[22%] md:w-[15%] bg-primary text-tertiary text-small rounded-full text-center p-2 cursor-pointer"
                          >
                          {{ slot }}
                        </div>
                      }
                    </div>
                  }



                  @if(changeSelectStart){
                    <!-- <std-select direction="down" class="max-w-[400px]"
                    typeOfFiltrableSelect="startsWith"
                    customLabel="label-input"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                    [currentValue]="selectStartDate"
                    customClassContaier="border-primary custom-select"
                    [filterable]="true"
                    placeholder="Seleziona un'orario"
                    (onChangeValue)="adjustDateSelect($event, 'startDate')"
                    label="Inizio"
                    customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar"
                    [data]="timetables"
                  ></std-select> -->
                  <div (click)="specialModalTimeToShow =   'time-booking-start'">
                    <std-input
                      customInputClass="custom-input"
                      customLabel="label-input"
                      class="pointer-events-none"
                      [type]="'time'"
                      [value]="selectStartDate?.label"
                      [label]="t('timeStart')"
                      [placeholder]="t('selectTime')"
                      labelPosition="top"

                    ></std-input></div>

                    } @if(!changedSelectStart){
                    <!-- <std-select direction="down" class="max-w-[400px]"
                    typeOfFiltrableSelect="startsWith"
                    customLabel="label-input"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                    [currentValue]="selectEndDate"
                    customClassContaier="border-primary custom-select"
                    [filterable]="true"
                    label="Fine"
                    placeholder="Seleziona un'orario"
                    (onChangeValue)="adjustDateSelect($event, 'endDate')"
                    customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar"
                    [data]="timetables"
                  ></std-select> -->

                  <div (click)="specialModalTimeToShow =   'time-booking-end'">
                    <std-input
                      customInputClass="custom-input"
                      customLabel="label-input"
                      class="pointer-events-none"
                      [type]="'time'"
                      [value]="selectEndDate?.label"
                      [label]="t('timeEnd')"
                      [placeholder]="t('selectTime')"
                      labelPosition="top"

                    ></std-input></div>

                    } @if(changedSelectStart && changeSelectEnd){
                    <!-- <std-select direction="down" class="max-w-[400px]"
                    typeOfFiltrableSelect="startsWith"
                    customLabel="label-input"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                    [currentValue]="selectEndDate"
                    customClassContaier="border-primary custom-select"
                    [filterable]="true"
                    label="Fine"
                    placeholder="Seleziona un'orario"
                    (onChangeValue)="adjustDateSelect($event, 'endDate')"
                    customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar"
                    [data]="timetables"
                  ></std-select> -->

                  <div (click)="specialModalTimeToShow =   'time-booking-end'">
                    <std-input
                      customInputClass="custom-input"
                      customLabel="label-input"
                      class="pointer-events-none"
                      [type]="'time'"
                      [value]="selectEndDate?.label"
                      [label]="t('timeEnd')"
                      [placeholder]="t('selectTime')"
                      labelPosition="top"

                    ></std-input></div>

                    } } @if(!isEditEvent){
                    <std-select direction="down" class="max-w-[400px]"
                      typeOfFiltrableSelect="startsWith"
                      customLabel="label-input"
                      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                      label="Operatore"
                      bindValue="id"
                      bindLabel="fullName"
                      (onChangeValue)="manageOperator($event)"
                      customClassContaier="border-primary custom-select"
                      placeholder="Seleziona operatore"
                      [data]="myOperators"
                    ></std-select>
                    @if(suggestedTimeSlots.length >0){
                      <div class="text-title text-primary label-input">Time slot consigliati</div>
                      } @if(suggestedTimeSlots.length > 0){
                      <div
                        class="flex overflow-x-scroll gap-x-[4%] md:gap-x-[2%] custom-scrollbar pb-2 select-none"
                        >
                        @for (slot of suggestedTimeSlots; track $index) {
                          <div
                            (click)="selectSuggestedSlot(slot)"
                            class="w-[22%] md:w-[15%] bg-primary text-tertiary text-small rounded-full text-center p-2 cursor-pointer"
                            >
                            {{ slot }}
                          </div>
                        }
                      </div>
                    }
                    @if(changeSelectStart){
                      <!-- <std-select direction="down" class="max-w-[400px]"
                      typeOfFiltrableSelect="startsWith"
                      customLabel="label-input"
                      [currentValue]="selectStartDate"
                      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                      customClassContaier="border-primary custom-select"
                      [filterable]="true"
                      placeholder="Seleziona un'orario"
                      (onChangeValue)="adjustDateSelect($event, 'startDate')"
                      label="Inizio"
                      customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar"
                      [data]="timetables"
                    ></std-select> -->
                    <div (click)="specialModalTimeToShow =   'time-booking-start'">
                      <std-input
                        customInputClass="custom-input"
                        customLabel="label-input"
                        class="pointer-events-none"
                        [type]="'time'"
                        [value]="selectStartDate?.label"
                        [label]="t('timeStart')"
                        [placeholder]="t('selectTime')"
                        labelPosition="top"

                      ></std-input></div>
                    }
                    @if(!changedSelectStart){
                      <!-- <std-select direction="down" class="max-w-[400px]"
                      typeOfFiltrableSelect="startsWith"
                      customLabel="label-input"
                      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                      customClassContaier="border-primary custom-select"
                      [filterable]="true"
                      label="Fine"
                      placeholder="Seleziona un'orario"
                      (onChangeValue)="adjustDateSelect($event, 'endDate')"
                      customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar"
                      [data]="timetables"
                      ></std-select
                      > -->


                      <div (click)="specialModalTimeToShow =   'time-booking-end'">
                        <std-input
                          customInputClass="custom-input"
                          customLabel="label-input"
                          class="pointer-events-none"
                          [type]="'time'"
                          [value]="selectEndDate?.label"
                          [label]="t('timeEnd')"
                          [placeholder]="t('selectTime')"
                          labelPosition="top"

                        ></std-input></div>


                        } @if(changedSelectStart && changeSelectEnd){
                        <!-- <std-select direction="down" class="max-w-[400px]"
                        typeOfFiltrableSelect="startsWith"
                        customLabel="label-input"
                        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                        customClassContaier="border-primary custom-select"
                        [currentValue]="selectEndDate"
                        [filterable]="true"
                        label="Fine"
                        placeholder="Seleziona un'orario"
                        (onChangeValue)="adjustDateSelect($event, 'endDate')"
                        customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar"
                        [data]="timetables"
                        ></std-select
                        > -->

                        <div (click)="specialModalTimeToShow =   'time-booking-end'">
                          <std-input
                            customInputClass="custom-input"
                            customLabel="label-input"
                            class="pointer-events-none"
                            [type]="'time'"
                            [value]="selectEndDate?.label"
                            [label]="t('timeEnd')"
                            [placeholder]="t('selectTime')"
                            labelPosition="top"

                          ></std-input></div>



                          } }

                          <div class="flex gap-2 w-full items-end">
                            @if (!hideSelectClient && !userApplied) {
                              <div class="w-[88%]">
                                <std-select direction="down" class="max-w-[400px]"
                                  (onChangeValue)="changeCustomer($event)"
                                  typeOfFiltrableSelect="includes"
                                  [filterable]="true"
                                  customLabel="label-input"
                                  customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                                  label="Cliente"
                                  customClassContaier="border-primary custom-select"
                                  placeholder="Seleziona cliente"
                                  [data]="customers"
          [currentValue]="
            isEditEvent
              ? getMyCustomer(currentEventSelected.userId)
              : { value: null, label: t('selectUser') }
          "
                                ></std-select>
                              </div>
                            }
                            @if (!hideSelectClient && searchedClient && userApplied) {
                              <div
                                class="w-[88%]"
                                >
                                <std-select direction="down" class="max-w-[400px]"
                                  (onChangeValue)="changeCustomer($event)"
                                  typeOfFiltrableSelect="includes"
                                  [filterable]="true"
                                  customLabel="label-input"
                                  customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                                  label="Cliente"
                                  customClassContaier="border-primary custom-select"
                                  placeholder="Seleziona cliente"
                                  [data]="customers"
          [currentValue]="{
            value: searchedClient.id,
            label: searchedClient.firstName + ' ' + searchedClient.lastName
          }"
                                ></std-select>
                              </div>
                            }
                            <!-- currentEventSelected.userId -->
                            <div class="w-[10%]">
                              <std-button
          (click)="
            showModalSearchClient = true;
            userNotFound = false;
            searchedClient = null
          "
                                buttonClass="bg-transparent text-title focus:bg-transparent hover:bg-transparent text-white text-medium p-0 flex items-center"
                                ><svg class="size-full" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99918 1.87524C5.5191 1.87524 1.87418 5.52017 1.87418 10.0002C1.87418 14.4803 5.5191 18.1252 9.99918 18.1252C14.4793 18.1252 18.1242 14.4803 18.1242 10.0002C18.1242 5.52017 14.4793 1.87524 9.99918 1.87524ZM13.7492 10.6252H10.6242V13.7502H9.37418V10.6252H6.24918V9.37525H9.37418V6.25025H10.6242V9.37525H13.7492V10.6252Z" fill="var(--primary)"/>
                              </svg>
                              </std-button
                              >
                            </div>
                          </div>

                          <std-input
                            customInputClass="custom-input"
                            customLabel="label-input"
                            labelPosition="top"
                            label="Note"
                            placeholder="Note"
                            [(ngModel)]="currentEvent.description"
                            type="text"
                          ></std-input>

                          <div class="flex gap-[4%]">
                            <div class="w-[48%]">
                              <std-button
                                (click)="showModalBooking = false"
                                buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                >Annulla</std-button
                                >
                              </div>
                              <div class="w-[48%]">
                                <std-button
                                  (click)="manageCalendar()"
          [disabled]="
            !currentEvent.price ||
            !currentEvent.operatorId ||
            !selectStartDate ||
            !selectEndDate
          "
                                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                  >Salva</std-button
                                  >
                                </div>
                              </div>
                            </div> </std-modal
                            >}

                            <!-- delete modal -->
                            @if(modalDelete){<std-modal [closeOnOutside]="false" cardClass="!max-w-[90vw] !top-[30vh]" [show]="modalDelete"
                              headerClass="bg-primary" (close)="modalDelete = false">
                              <div header class="text-white">Cancella prenotazione</div>
                              <div content class="min-w-[250px] max-w-[400px] gap-4 grid max-h-[70vh] overflow-y-scroll custom-scrollbar">
                                <div class="w-full flex" *transloco="let t">
                                  <std-button class="w-[48%] mr-[4%]" (click)="deleteBooking()" size="sm"
                                    buttonClass="bg-red-500 text-white hover:bg-red-500 active:bg-red-500 focus:bg-red-500">Conferma</std-button>
                                  <std-button class="w-[48%]" (click)="modalDelete = false" size="sm">Annulla</std-button>
                                </div>
                              </div>
                            </std-modal>}
                            @if(savedEventMoving){<std-modal [closeOnOutside]="false" cardClass="!max-w-[90vw] !top-[30vh]" [show]="savedEventMoving ? true : false"
                              headerClass="bg-primary" (close)="savedEventMoving = null">
                              <div header class="text-white">Sposta prenotazione</div>
                              <div content class="min-w-[250px] max-w-[400px] gap-4 grid max-h-[70vh] overflow-y-scroll custom-scrollbar">
                                <div class="w-full flex" *transloco="let t">
                                  <std-button class="w-[48%] mr-[4%]" (click)="moveEventDo()" size="sm"
                                    buttonClass="bg-red-500 text-white hover:bg-red-500 active:bg-red-500 focus:bg-red-500">Conferma</std-button>
                                  <std-button class="w-[48%]" (click)="savedEventMoving = null;calendarPrenotations()" size="sm">Annulla</std-button>
                                </div>
                              </div>
                            </std-modal>}
                            @if(showModalSearchClient){<std-modal
                                  [closeOnOutside]="false"
                                  cardClass="!max-w-[90vw] !z-[11111] min-w-[50vw] fixed"
                                  [show]="showModalSearchClient"
                                  headerClass="bg-primary"
                                  (close)="showModalSearchClient = false"
                                  >
                                  <div header class="text-white">
                                    {{
                                    addUser
                                    ? "Completa i dati e invita utente nell'app"
                                    : "Cerca cliente nell'app"
                                    }}
                                  </div>
                                  <div
                                    content
                                    class="min-w-[250px] gap-4 grid max-h-[70vh] overflow-y-scroll custom-scrollbar"
                                    >
                                    @if(searchedClient){
                                      <div class="text-primary text-medium grid gap-4 my-4">
                                        <div>
                                          <span class="font-bold">Nome: </span> {{ searchedClient?.firstName }}
                                        </div>
                                        <div>
                                          <span class="font-bold">Cognome: </span> {{ searchedClient?.lastName }}
                                        </div>
                                        <div>
                                          <span class="font-bold">Email: </span> {{ searchedClient?.email }}
                                        </div>
                                        <div>
                                          <span class="font-bold">Telefono: </span> {{ searchedClient?.phone }}
                                        </div>
                                      </div>
                                      } @if(!searchedClient){ @if(addUser){
                                      <std-input
                                        customInputClass="custom-input"
                                        customLabel="label-input"
                                        labelPosition="top"
                                        label="Nome"
                                        placeholder="Nome"
                                        [(ngModel)]="specificSearchName"
                                        type="text"
                                        ></std-input
                                        >}
                                        <std-input
                                          customInputClass="custom-input"
                                          customLabel="label-input"
                                          labelPosition="top"
                                          label="Cognome"
                                          placeholder="Cognome"
                                          [(ngModel)]="specificSearchSurname"
                                          type="text"
                                        ></std-input>
                                        <std-input
                                          customInputClass="custom-input"
                                          customLabel="label-input"
                                          labelPosition="top"
                                          label="Telefono"
                                          placeholder="Telefono"
                                          [(ngModel)]="specificSearchPhone"
                                          type="text"
                                        ></std-input>
                                        @if(addUser){
                                          <std-input
                                            customInputClass="custom-input"
                                            customLabel="label-input"
                                            labelPosition="top"
                                            label="Email"
                                            placeholder="Email"
                                            [(ngModel)]="specificSearchEmail"
                                            type="text"
                                            ></std-input
                                            >} }
                                            <div class="w-full flex justify-between" *transloco="let t">
                                              <std-button
                                                (click)="showModalSearchClient = false"
                                                size="sm"
                                                buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                                >Annulla</std-button
                                                >
                                                @if(!searchedClient && !addUser){
                                                  <std-button
                                                    (click)="searchClient()"
                                                    size="sm"
                                                    buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                                    >Cerca</std-button
                                                    >} @if(searchedClient&& !addUser){
                                                    <std-button
                                                      (click)="applySearchedClient()"
                                                      size="sm"
                                                      buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                                      >Applica</std-button
                                                      >} @if(addUser){
                                                      <std-button
        [ngClass]="{
          'pointer-events-none opacity-35':
            !specificSearchName ||
            !specificSearchSurname ||
            !specificSearchPhone
        }"
                                                        (click)="inviteClient()"
                                                        size="sm"
                                                        buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                                        >Invita</std-button
                                                        >} @if(userNotFound && !addUser){
                                                        <std-button
                                                          (click)="addUser = true"
                                                          size="sm"
                                                          buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                                          >Invita</std-button
                                                          >
                                                        }
                                                      </div>
                                                    </div> </std-modal
                                                    >}

                                                    @if(specialModalTimeToShow === 'time-booking-start'){
                                                      <div class="flex h-screen w-screen bg-black !bg-opacity-35 place-content-center items-center fixed top-0 left-0 z-[10000]">
                                                        <std-time-picker [step5Minutes]="true" [showClock]="false" [use24h]="true" [startingTime]="selectStartDate?.label" (changeDate)="adjustDateSelect({label:$event.formattedTime}, 'startDate')">
                                                          <div footer class="mt-6 place-content-center flex gap-4">
                                                            <div class="w-full"> <std-button
                                                              buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                                              (click)="specialModalTimeToShow = ''"
                                                              class="w-[200px]"
                                                              >{{ t("close") }}</std-button
                                                            ></div>

                                                          </div>
                                                        </std-time-picker></div>
                                                      }

                                                      @if(specialModalTimeToShow === 'time-booking-end'){
                                                        <div class="flex h-screen w-screen bg-black !bg-opacity-35 place-content-center items-center fixed top-0 left-0 z-[10000]">
                                                          <std-time-picker [step5Minutes]="true" [showClock]="false" [use24h]="true" [startingTime]="selectEndDate?.label" (changeDate)="adjustDateSelect({label:$event.formattedTime}, 'endDate')">
                                                            <div footer class="mt-6 place-content-center flex gap-4">
                                                              <div class="w-full"> <std-button
                                                                buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                                                                (click)="specialModalTimeToShow = ''"
                                                                class="w-[200px]"
                                                                >{{ t("close") }}</std-button
                                                              ></div>

                                                            </div>
                                                          </std-time-picker></div>
                                                        }
                                                      </div>

